{
  "account-page-container": {
    "text": {
      "account": "My account",
      "logout": "Logout",
      "my-appointments": "My appointments",
      "my-profile": "My profile",
      "my-salons": "My salons"
    }
  }
}
